import React, { useEffect, useState } from "react";
import ApiDataBase from "server";
import UseContext from "hooks/useContext";
import SectionWrapper, {
    FormField,
} from "pages/createMission/components/SectionWrapper";
import MultiDdl from "components/componentsForm/multiDdl";

const PrerequisTemplate = () => {
    const { templateData, setTemplateData } = UseContext();
    const [tools, setTools] = useState([]);
    const [licences, setLicences] = useState([]);
    const [languages, setLanguages] = useState([]);

    useEffect(() => {
        ApiDataBase.getAllLicence(
            (res) => setLicences(res),
            (err) => console.warn(err)
        );
        ApiDataBase.getListTools(
            (res) => setTools(res),
            (err) => console.warn(err)
        );
        ApiDataBase.getListLanguages(
            (res) => setLanguages(res),
            (err) => console.warn(err)
        );
    }, []);

    const handleTools = (selected) =>
        setTemplateData((prev) => ({ ...prev, tools: selected }));
    const handleLicences = (selected) =>
        setTemplateData((prev) => ({ ...prev, licences: selected }));
    const handleLanguages = (selected) =>
        setTemplateData((prev) => ({ ...prev, languages: selected }));

    return (
        <SectionWrapper
            title="Pré-requis"
            description="Indiquez les compétences et équipements nécessaires."
        >
            <FormField label="Matériel nécessaire" optional>
                <MultiDdl
                    data={tools}
                    selectArray={handleTools}
                    defaultSelect={templateData.tools || []}
                />
            </FormField>
            <FormField label="Permis nécessaire" optional>
                <MultiDdl
                    data={licences}
                    selectArray={handleLicences}
                    defaultSelect={templateData.licences || []}
                />
            </FormField>
            <FormField label="Langue nécessaire" optional>
                <MultiDdl
                    data={languages}
                    selectArray={handleLanguages}
                    defaultSelect={templateData.languages || []}
                />
            </FormField>
        </SectionWrapper>
    );
};

export default PrerequisTemplate;
